import { useSyncExternalStore } from 'react';

const emptySubscribe = () => () => {};

/**
 * Hook to detect if component has mounted (client-side).
 *
 * Uses useSyncExternalStore for hydration-safe client detection
 * without triggering cascading renders (React Compiler compliant).
 *
 * @see https://tkdodo.eu/blog/avoiding-hydration-mismatches-with-use-sync-external-store
 * @see https://react.dev/reference/react/useSyncExternalStore
 *
 * @returns true on client after hydration, false during SSR
 */
export function useHasMounted(): boolean {
  return useSyncExternalStore(
    emptySubscribe,
    () => true,
    () => false,
  );
}
